import { render, staticRenderFns } from "./FlightItems.vue?vue&type=template&id=2096df20&scoped=true&"
import script from "./FlightItems.vue?vue&type=script&lang=js&"
export * from "./FlightItems.vue?vue&type=script&lang=js&"
import style0 from "./FlightItems.vue?vue&type=style&index=0&id=2096df20&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2096df20",
  null
  
)

export default component.exports